import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import api from '../../utils/api';
import Dashboard from './Dashboard';
import SuperAdminDashboard from '../admin/SuperAdminDashboard';

export default function DashboardWrapper() {
    const location = useLocation();
    const { _getUser } = useAuth();
    const [user, setUser] = useState(_getUser() || null);

    // Check if token is in URL and fetch user data if needed
    useEffect(() => {
        const urlParams = new URLSearchParams(location.search);
        const tokenFromUrl = urlParams.get('token');
        
        const fetchUserFromToken = async () => {
            if (tokenFromUrl) {
                try {
                    // Fetch user data using the token from URL
                    const response = await api.get('user/me');
                    const userData = response.data.data;
                    // Store in component state only (not localStorage to avoid affecting super admin tab)
                    setUser(userData);
                } catch (error) {
                    console.error('Failed to fetch user from token:', error);
                    // Fallback to localStorage user if fetch fails
                    const storedUser = _getUser();
                    if (storedUser) {
                        setUser(storedUser);
                    }
                }
            } else {
                // Use user from localStorage if no token in URL
                const storedUser = _getUser();
                if (storedUser) {
                    setUser(storedUser);
                }
            }
        };

        fetchUserFromToken();
    }, [location.search, _getUser]);

    // Check if user is super admin
    if (user?.role === 'super_admin') {
        return <SuperAdminDashboard />;
    }

    // Return regular dashboard for other users
    return <Dashboard />;
}

